import s from '../collegesItem.module.css'
import {useMemo, useState} from "react";
import {Button} from "antd";
import {useAddAlert} from "@/hooks/useAddAlert";
import { useSelector } from "react-redux";
import { getRolesSD } from "@/selectors";
import { getInArr } from "@/helpers/getInArr";
import { InputSelect, InputNew } from "@UI/InputNew";
import { useInputNew } from "@UI/InputNew/useInputNew";
import {usersAPI} from "@api"

const ModalAddRole = ({setActive, userId, rolesUser, update}) => {
  const { data: allRoles } = useSelector(state => state.allRoles);

  const rolesAvailableForAdding = useMemo(() => {
    return allRoles
    .filter((role) => {
      if(role?.is_active === false) return;
      if (getInArr(role.role, [...rolesUser?.map((el)=>{return el.item_name})])) return false;
      return true;
    })
    .map((role) => ({label: role.name, value: role.role}))
  }, [allRoles, rolesUser])

  const addAlert = useAddAlert();
  const [loading, setLoading] = useState(false);
  const [role, setRole] = useState("");
  const [bindSelect] = useInputNew({
    name: "thematic",
    value: role,
    onChange: setRole,
    placeholder: "Выберите роль",
    options: rolesAvailableForAdding,
  });

  const save = () => {
    if (role) {
       
        setLoading(true)
        usersAPI.updateRoles({
            id: userId,
            data: { roles: [...rolesUser, {item_name: role} ] }
        })
        .then((res) => {
            if (res.data.status === "success") {
                addAlert({ title: "Роль успешно добавлена" });
                setActive(false);
                update("roles");
            }
        })
        .finally((res)=>{
            setLoading(false);
        });
    } 
    else {
      addAlert({ type: "error", title: "Не выбрана роль" });
    }
  }

  return <div className="modal_departments">
    <h2 className="modal__title">Добавить роль</h2>
    <div className={s.body}>
          <span style={{fontSize:'12px', color:'#000000e0', fontWeight:'400', marginBottom:'-10px'}}>Выберите роль</span>
          <InputSelect style={{width:'100%'}} className={s.input} {...bindSelect} />
          
          <Button disabled={loading} onClick={save}>Сохранить</Button>
    </div>
  </div>
}
export default ModalAddRole;